/**
 * ViewPurchaseOrderWrapper
 *
 * Purpose:
 * - Wraps PO view page to route back into vendor orders using returnTab.
 */
import React from "react";
import { PURCHASE_ORDER, SUPPLIERS, VENDOR, VENDOR_ORDERS } from "../../constants/route-paths";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import ViewPurchaseOrderComponent from '../../components/po/view'
import { VENDOR_TAB, VENDOR_URL_PARAM } from "../../constants/vendor.contant";

function ViewPurchaseOrderWrapper() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const params = useParams();

  const returnTab = searchParams.get(VENDOR_URL_PARAM.RETURN_TAB) || VENDOR_TAB.PURCHASE_ORDERS;
  const returnSubTab = searchParams.get(VENDOR_URL_PARAM.RETURN_SUB_TAB);

  const cancelHandler = () => {
    if (returnTab) {
      // Return to vendor orders with the correct tab and sub-tab
      let url = `/${VENDOR}/${VENDOR_ORDERS}?${VENDOR_URL_PARAM.TAB}=${returnTab}`;
      if (returnSubTab) {
        url += `&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}`;
      }
      navigate(url);
    } else {
      // Default to original supplier path
      navigate(`/${SUPPLIERS}/${PURCHASE_ORDER}`);
    }
  };

  const editHandler = () => {
    navigate(`/${VENDOR}/${VENDOR_ORDERS}/purchase-order/edit/${params.poId}/project?returnTab=${returnTab}&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}`);
  };

  return (
    <div className="purchase-order-block" data-cy="view-purchase-order">
      <h2 className="content-heading text-uppercase" data-cy="heading">View Purchase Order</h2>
      <div className="col-12 breadcrumb-block p-0" data-cy="breadcrumb">
        <Breadcrumb>
          <Breadcrumb.Item onClick={cancelHandler} data-cy="purchase-order">
            {returnTab ? "Orders" : "Purchase Order"}
          </Breadcrumb.Item>
          <Breadcrumb.Item active data-cy="view-purchase-order">View Purchase Order</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <ViewPurchaseOrderComponent
        poId={params.poId}
        cancelHandler={cancelHandler}
        editHandler={editHandler}
        sourcePage="orders-list"
      />

    </div>
  );
}

export default ViewPurchaseOrderWrapper;
